import { useState, useImperativeHandle, forwardRef } from "react";
import Snackbar from "@mui/material/Snackbar";

interface CustomNotificationProps {
  anchorOrigin?: {
    vertical: "top" | "bottom";
    horizontal: "left" | "center" | "right";
  };
}

export type CustomNotificationHandle = {
  showSnackbar: (message: string) => void;
};

const CustomSnackbar = forwardRef<
  CustomNotificationHandle,
  CustomNotificationProps
>(({ anchorOrigin = { vertical: "bottom", horizontal: "right" } }, ref) => {
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const showSnackbar = (message: string) => {
    setSnackbarMessage(message);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    showSnackbar,
  }));

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={open}
      onClose={handleClose}
      message={snackbarMessage}
      key={`${anchorOrigin.vertical}-${anchorOrigin.horizontal}`}
      autoHideDuration={3000}
    />
  );
});

export default CustomSnackbar;
